export const TELEFONE = "ZGFzZGFzNDU2NDUzMDIxNDUwMjE1NjA0NTYyMTBzYTEyMzEwZDY1NTkwMkA=";